import React from 'react';
import { IconAlertTriangle, IconCheck, IconInfoCircle } from '@tabler/icons-react';

const KnowledgeDiagnostic = ({ diagnostic }) => {
  if (!diagnostic) return null;

  const score = diagnostic.quality_score || 0;
  const percentage = Math.round(score * 100);
  let qualityLevel = 'low';
  let qualityLabel = 'Baixa';
  if (score >= 0.7) {
    qualityLevel = 'good';
    qualityLabel = 'Boa';
  } else if (score >= 0.4) {
    qualityLevel = 'medium';
    qualityLabel = 'Média';
  }

  return (
    <div className="awc-diagnostic">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h4 className="awc-diagnostic__title mb-0">
          Diagnóstico do Arquivo
        </h4>
        <span className="awc-diagnostic__filename">
          {diagnostic.file_name}
        </span>
      </div>

      <div className="d-flex align-items-center gap-2 mb-1">
        <span className="awc-diagnostic__quality-label">Qualidade: </span>
        <strong className={`awc-diagnostic__quality-value--${qualityLevel}`}>
          {qualityLabel} ({percentage}%)
        </strong>
      </div>
      <div className="awc-diagnostic__bar">
        <div
          className={`awc-diagnostic__bar-fill awc-diagnostic__bar-fill--${qualityLevel}`}
          style={{ width: `${percentage}%` }}
        />
      </div>

      {diagnostic.total_items > 0 && (
        <p className="awc-diagnostic__stats">
          {diagnostic.usable_items} de {diagnostic.total_items} itens utilizáveis
        </p>
      )}

      {diagnostic.issues && diagnostic.issues.length > 0 && (
        <div className="mb-3">
          <h5 className="awc-diagnostic__section-title awc-diagnostic__section-title--issues">
            <IconAlertTriangle size={14} className="me-1" />
            Problemas encontrados
          </h5>
          <ul className="awc-diagnostic__list awc-diagnostic__list--issues">
            {diagnostic.issues.map((issue, i) => (
              <li key={i}>{issue}</li>
            ))}
          </ul>
        </div>
      )}

      {diagnostic.suggestions && diagnostic.suggestions.length > 0 && (
        <div className="mb-3">
          <h5 className="awc-diagnostic__section-title awc-diagnostic__section-title--suggestions">
            <IconInfoCircle size={14} className="me-1" />
            Sugestões
          </h5>
          <ul className="awc-diagnostic__list awc-diagnostic__list--suggestions">
            {diagnostic.suggestions.map((sug, i) => (
              <li key={i}>{sug}</li>
            ))}
          </ul>
        </div>
      )}

      {diagnostic.summary && (
        <p className="awc-diagnostic__summary">
          {diagnostic.summary}
        </p>
      )}
    </div>
  );
};

export default KnowledgeDiagnostic;
